const e=e=>e.split("").reduce(((e,t)=>(e<<5)-e+t.charCodeAt(0)|0),0);export{e as hashString};
//# sourceMappingURL=functions.js.map
